import React, { useCallback, useEffect, useState } from 'react';

import { getUserStripeCustomers } from '../../services/UsersService';
import { stripeCustomerUrl } from '../../libs/stripeLib';

import UserStripeCharges from './UserStripeCharges';

type Props = {
  userId: string;
};
const UserStripeCustomers = ({ userId }: Props) => {
  const [customerApiStatus, setCustomersApiStatus] = useState('loading');
  const [customers, setCustomers] = useState<{ id: string }[]>([]);
  const [selectedCustomer, setSelectedCustomerId] = useState<string | null>(
    null
  );

  const fetchUserStripeCustomers = useCallback(() => {
    setCustomersApiStatus('loading');
    getUserStripeCustomers(userId)
      .then(stripeCustomers => {
        setCustomers(stripeCustomers);
        if (stripeCustomers.length > 0) {
          setSelectedCustomerId(stripeCustomers[0].id);
        }
        setCustomersApiStatus('success');
      })
      .catch(() => {
        setCustomersApiStatus('error');
      });
  }, [userId, setCustomers, setSelectedCustomerId, setCustomersApiStatus]);

  useEffect(() => {
    fetchUserStripeCustomers();
  }, [fetchUserStripeCustomers]);

  if (customerApiStatus === 'loading') {
    return <div>Loading Stripe customer details...</div>;
  }

  if (customerApiStatus === 'error') {
    return (
      <div>An error occurred while loading the stripe customer details.</div>
    );
  }

  if (customers.length === 0) {
    return <div>This user does not have an associated Stripe customer.</div>;
  }

  return (
    <div>
      {customers.map(customer => (
        <div key={customer.id}>
          <span>
            <a
              href={stripeCustomerUrl(customer.id)}
              target='_blank'
              rel='noreferrer'
            >
              Stripe Customer {customer.id}
            </a>
          </span>
          {customer.id !== selectedCustomer && (
            <button
              type='button'
              onClick={() => setSelectedCustomerId(customer.id)}
            >
              Show Charges
            </button>
          )}
          {customer.id === selectedCustomer && (
            <UserStripeCharges userId={userId} stripeCustomerId={customer.id} />
          )}
        </div>
      ))}
    </div>
  );
};

export default UserStripeCustomers;
